import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DOCUMENT_FEATURE_KEY, DocumentState } from './documents.reducer';
import { selectQueryParams, selectRouteParams } from '@frontend/util-ngrx';
import { Params } from '@angular/router';

export const selectDocumentState = createFeatureSelector<DocumentState>(DOCUMENT_FEATURE_KEY);

export const selectDocumentLoaded = createSelector(selectDocumentState, (state: DocumentState) => state.loaded);

export const selectDocumentError = createSelector(selectDocumentState, (state: DocumentState) => state.error);

export const selectCategoryDocuments = createSelector(selectDocumentState, (state: DocumentState) => state.documents);

export const selectCategoryFilters = createSelector(selectDocumentState, (state: DocumentState) => state.filters);

export const selectCurrentCategoryData = createSelector(
  selectDocumentState,
  (state: DocumentState) => state.current_category
);

export const selectActiveFilters = createSelector(selectQueryParams, (queryParams: Params): number[] | undefined => {
  return queryParams?.['filterIds'] != null
    ? queryParams['filterIds'].split(',').map((value: string) => +value)
    : undefined;
});

export const selectDocumentTotalItems = createSelector(
  selectDocumentState,
  (state: DocumentState) => state.total_items
);

export const selectDocumentCurrentPage = createSelector(
  selectDocumentState,
  (state: DocumentState) => state.current_page
);

export const selectDocumentById = (id: number) =>
  createSelector(selectCategoryDocuments, (documents) => documents.find((doc) => doc.id === id));

export const selectCurrentDocument = createSelector(
  selectCategoryDocuments,
  selectRouteParams,
  (documents, routeParams) => {
    const documentId = routeParams['documentId'] ? +routeParams['documentId'] : undefined;
    if (!documentId) return;

    return documents.find((doc) => doc.id === documentId);
  }
);
